import React from 'react';


const ChefView = (props) => {

    // console.log("props in carousel ::",props);

    return (
        <>
            <div className="cardNewBox">
                <img src={props.cardImage} alt=""/>
                <div className="title"> {props.cardTitle}</div>
                <p>
                    {props.cardDescription}
                </p>
            </div>
        </>
    );
}

export default ChefView;